import { render, staticRenderFns } from "./Mandatory.vue?vue&type=template&id=a48b2dfe&"
import script from "./Mandatory.vue?vue&type=script&lang=js&"
export * from "./Mandatory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports